import axios from 'axios';
import { X } from 'lucide-react';
import { useContext, useState } from 'react';
import { ProgramContext } from '../../context/ProgramsContext';

const GenerateScheduleModal = ({ onClose }) => {
    const { programTemplates, reverseTaskDataToProgram, setHeaderData, setPlan, loadingTemplates, plan, programId } = useContext(ProgramContext);
    const [selectedProtocolId, setSelectedProtocolId] = useState(null);
    const [isImporting, setIsImporting] = useState(false);
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);

    const handleImportProtocol = async () => {
        if (!selectedProtocolId) return;
        setIsImporting(true);

        try {
            axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
            const res = await axios.post(window.ajaxLink + "cloud_programs/programs-details", {
                id: selectedProtocolId,
            });
            if (res.data.responseData) {
                var taskObj = [];

                for (var day of res.data.responseData.day_data) {
                    //day.day = day.day + diffDays;
                    for (var tsk of day.tasks_arr) {
                        delete tsk.task_id;

                        var tasksData = {};
                        tasksData.dayInx = res.data.responseData.day_data.indexOf(day).toString();
                        tasksData.taskInx = day.tasks_arr.indexOf(tsk).toString();
                        tasksData.activityPool = tsk.activity_data;
                        tasksData.workoutDesc = tsk.description;
                        tasksData.workoutDuration = tsk.duration;
                        tasksData.exercise_number = tsk.exercise_number;
                        tasksData.workoutLevel = tsk.level;
                        tasksData.workoutRom = tsk.rom;
                        tasksData.workoutName = tsk.task_name || "";
                        taskObj.push(tasksData);
                    }
                }
                const transformedData = reverseTaskDataToProgram({ ...res.data.responseData, reward: 0 })
                setHeaderData(
                    prev =>
                    ({
                        ...prev,
                        problemArea: transformedData?.problemArea,
                        problemId: transformedData?.problemId,
                        protocol: transformedData?.protocol,
                        subtype: transformedData?.cpgProtocolId ? transformedData?.subtype : "",
                        subtypeId: transformedData?.cpgProtocolId ? transformedData?.subtypeId : 0,
                        status: transformedData?.status,
                        startDate: new Date(transformedData?.startDate).toISOString().split('T')[0],
                        planLength: transformedData?.planLength,
                        totalReward: transformedData?.totalReward,
                        programName: transformedData?.programName,
                        cpgProtocol: transformedData?.cpgProtocol || "",
                        cpgProtocolId: transformedData?.cpgProtocolId || 0,
                    }))
                setPlan({
                    weeks: transformedData?.weeks
                })
                localStorage.setItem("maxDisabledWeek", 0)
            }

            onClose(); // optionally close modal after success
        } catch (error) {
            console.error(error);
        } finally {
            setIsImporting(false);
        }
    };

    // function planHasData(plan) {
    //     if (!plan?.weeks?.length) return false;

    //     return plan.weeks.some(week =>
    //         week.days?.some(day =>
    //             Array.isArray(day.activities) && day.activities.length > 0
    //         )
    //     );
    // }


    return (
        <>
            <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50 animate-fade-in-up">
                <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[90vw] sm:max-w-lg p-8 transform transition-all">

                    {/* Header */}
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-2xl font-bold text-gray-800">Generate from Pattern</h2>
                        <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200 transition">
                            <X />
                        </button>
                    </div>

                    {/* Protocol List */}
                    <div className="mb-6">
                        <h3 className="text-lg font-semibold text-gray-700 mb-2">Select a Template</h3>
                        <div className="border border-gray-200 rounded-lg max-h-60 overflow-y-auto divide-y divide-gray-100">
                            {loadingTemplates ? (
                                <div className="flex items-center justify-center p-4">
                                    <svg className="animate-spin h-6 w-6 text-[#166273]" viewBox="0 0 24 24" fill="none">
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        />
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                        />
                                    </svg>
                                    <span className="ml-3 text-sm text-gray-600">Loading templates...</span>
                                </div>
                            ) : programTemplates.length === 0 ? (
                                <div className="p-3 text-gray-500 text-sm">No templates available.</div>
                            ) : (
                                programTemplates.map((template) => (
                                    <label
                                        key={template.key}
                                        className="flex items-center px-4 py-2 hover:bg-gray-50 cursor-pointer gap-2"
                                    >
                                        <input
                                            type="radio"
                                            name="protocol"
                                            value={template.key}
                                            checked={selectedProtocolId === template.key}
                                            onChange={() => setSelectedProtocolId(template.key)}
                                        />
                                        <span>{template.value}</span>
                                    </label>
                                ))
                            )}
                        </div>
                    </div>

                    {/* Import Button */}
                    <div className="mt-8 flex justify-end">
                        <button
                            onClick={() => {
                                if (programId) {
                                    setShowConfirmDialog(true)
                                } else {
                                    handleImportProtocol();
                                }
                            }}
                            disabled={!selectedProtocolId || isImporting}
                            className={`px-6 py-2 bg-[#166273] text-white font-semibold rounded-lg shadow-md transition-all ${isImporting ? 'opacity-70 cursor-wait' : 'hover:bg-[#166273]/90'
                                }`}
                        >
                            {isImporting ? (
                                <span className="flex items-center gap-2">
                                    <svg
                                        className="animate-spin h-5 w-5 text-white"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        />
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                        />
                                    </svg>
                                    Importing...
                                </span>
                            ) : (
                                'Import Pattern'
                            )}
                        </button>
                    </div>


                </div>
            </div>

            {showConfirmDialog && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6 space-y-4">
                        <h3 className="text-lg font-semibold text-gray-800">Confirm Import</h3>
                        <p className="text-sm text-gray-600">
                            Are you sure you want to import this pattern? It will <strong className='text-red-500'>replace all existing data</strong> in the plan.
                        </p>
                        <div className="flex justify-end gap-3 pt-4">
                            <button
                                onClick={() => setShowConfirmDialog(false)}
                                className="px-4 py-2 text-gray-700 bg-gray-100 rounded hover:bg-gray-200 transition"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => {
                                    setShowConfirmDialog(false);
                                    handleImportProtocol();
                                }}
                                className="px-4 py-2 bg-[#166273] text-white rounded hover:bg-[#166273]/90 transition"
                            >
                                Yes, Replace
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default GenerateScheduleModal;
